import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Heart, Users, Award, Clock, Phone, MapPin, CheckCircle, Star, ArrowRight, Activity, Shield, Target, BookOpen, Baby, Calendar, Flower2, Hand, Waves, Sparkles, Compass, RotateCcw } from 'lucide-react';
import { Link } from 'react-router-dom';
const Index = () => {
  const servizi = [{
    title: "Fisioterapia",
    description: "Trattamenti personalizzati per il recupero funzionale e il benessere fisico",
    icon: Heart,
    image: "/images/fisioterapia_centro_1.jpeg"
  }, {
    title: "Riabilitazione Motoria",
    description: "Programmi specifici per il recupero della mobilità e della forza muscolare",
    icon: Activity,
    image: "/images/fisioterapia_centro_2.webp"
  }, {
    title: "Ginnastica Posturale",
    description: "Correzione dei difetti posturali e prevenzione dei disturbi muscolo-scheletrici",
    icon: Target,
    image: "/images/terapia_esercizi_1.jpeg"
  }, {
    title: "Specialista Età Evolutiva",
    description: "Trattamenti dedicati ai bambini e adolescenti per una crescita sana",
    icon: Users,
    image: "/images/ginnastica_posturale_1.jpeg"
  }];
  const qualifiche = ["Terapista della Riabilitazione", "Tecnico Chinesiologo", "Istruttore Tecnico Sportivo", "Specialista in Età Evolutiva", "Specialista in Ginnastica Posturale e Correttiva", "Master Universitario in Riabilitazione Motoria"];
  const vantaggi = [{
    icon: Award,
    title: "Esperienza Professionale",
    description: "Oltre 25 anni di esperienza nel settore della riabilitazione motoria"
  }, {
    icon: Shield,
    title: "Approccio Personalizzato",
    description: "Ogni trattamento è studiato specificamente per le esigenze del paziente"
  }, {
    icon: Users,
    title: "Specializzazione Pediatrica",
    description: "Competenza specifica nel trattamento di bambini e adolescenti"
  }, {
    icon: Target,
    title: "Tecniche Innovative",
    description: "Utilizzo delle più moderne tecniche di riabilitazione e fisioterapia"
  }];
  return <div className="min-h-screen">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary/10 via-secondary/5 to-accent/10 section-padding overflow-hidden">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <Badge className="bg-primary/10 text-primary border-primary/20">
                  Centro di Riabilitazione Motoria
                </Badge>
                <h1 className="hero-text xl:text-5xl">
                  Dott. Peppino S. Papa
                </h1>
                <p className="text-xl text-muted-foreground leading-relaxed">
                  Fisioterapia e Chinesiologia - Terapia della Neuropsicomotricità dell'Età Evolutiva, 
                  specialista in riabilitazione motoria e trattamenti per bambini e adulti. 
                  Il tuo benessere è la nostra priorità.
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Button size="lg" className="medical-gradient text-white hover:opacity-90 group" onClick={() => window.open('https://www.sumupbookings.com/dott-papa-peppino-salvatore', '_blank')}>
                  Prenota una Visita
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 smooth-transition" />
                </Button>
                <Button size="lg" variant="outline" className="border-primary text-primary hover:bg-primary/5" asChild>
                  <a href="tel:+393475391433">
                    <Phone className="mr-2 h-4 w-4" />
                    347.5391433
                  </a>
                </Button>
              </div>

              <div className="flex flex-wrap gap-2">
                {qualifiche.slice(0, 3).map((qualifica, index) => <Badge key={index} variant="secondary" className="text-xs">
                    {qualifica}
                  </Badge>)}
                <Badge variant="outline" className="text-xs">
                  +3 altre qualifiche
                </Badge>
              </div>
            </div>

            <div className="relative">
              <div className="relative z-10 medical-card p-8 float-animation">
                <img src="/images/IMG_3343.jpg" alt="Dott. Peppino Salvatore Papa - Fisioterapista" className="w-full h-80 doctor-photo rounded-lg" />
                <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-lg soft-shadow">
                  <div className="flex items-center space-x-2">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
                    </div>
                    <span className="text-sm font-medium">5.0</span>
                  </div>
                  <p className="text-xs text-muted-foreground mt-1">Oltre 500 pazienti soddisfatti</p>
                </div>
              </div>
              
              {/* Elementi decorativi */}
              <div className="absolute top-10 -left-10 w-20 h-20 bg-primary/10 rounded-full blur-xl"></div>
              <div className="absolute bottom-10 -right-10 w-32 h-32 bg-secondary/10 rounded-full blur-xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Servizi Section */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-primary/10 text-primary border-primary/20">
              I Nostri Servizi
            </Badge>
            <h2 className="text-4xl font-bold">Trattamenti Specializzati</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Offriamo una gamma completa di servizi di riabilitazione motoria 
              personalizzati per ogni esigenza
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {servizi.map((servizio, index) => <Card key={index} className="medical-card group hover:scale-105 smooth-transition">
                <div className="relative overflow-hidden rounded-t-xl">
                  <img src={servizio.image} alt={servizio.title} className="w-full h-48 object-cover group-hover:scale-110 smooth-transition" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <servizio.icon className="h-8 w-8 text-white" />
                  </div>
                </div>
                <CardHeader>
                  <CardTitle className="text-lg">{servizio.title}</CardTitle>
                  <CardDescription>{servizio.description}</CardDescription>
                </CardHeader>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Fitness e Potenziamento Section */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-secondary/10 text-secondary border-secondary/20">
              Fitness e Potenziamento
            </Badge>
            <h2 className="text-4xl font-bold">Allenamento Personalizzato</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Servizi specializzati di fitness terapeutico, potenziamento muscolare 
              e massaggi sportivi con trainer dedicato
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/fitness_training_3.jpeg" 
                  alt="Personal Training"
                  className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <Users className="h-6 w-6 text-white" />
                  </div>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Personal Training</CardTitle>
                <CardDescription>
                  Allenamento personalizzato con trainer dedicato per il potenziamento muscolare
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Trainer qualificato dedicato</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Programmi personalizzati</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Monitoraggio progressi</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/riprogrammazione_muscolare_2.webp" 
                  alt="Riprogrammazione Muscolare"
                  className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <Activity className="h-6 w-6 text-white" />
                  </div>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Riprogrammazione Muscolare</CardTitle>
                <CardDescription>
                  Rieducazione neuromuscolare avanzata per correggere i pattern motori
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Analisi del movimento</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Correzione pattern motori</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Biofeedback muscolare</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/massaggio_sportivo_2.jpeg" 
                  alt="Massaggio Sportivo"
                  className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <Heart className="h-6 w-6 text-white" />
                  </div>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Massaggio Sportivo</CardTitle>
                <CardDescription>
                  Trattamenti decontratturanti e miofasciali per sportivi e recupero muscolare
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Massaggio decontratturante</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Rilascio miofasciale</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Recupero accelerato</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <Button size="lg" className="medical-gradient text-white" onClick={() => window.location.href = '/servizi'}>
              Scopri Tutti i Servizi Fitness
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </section>

      {/* Specializzazione Disturbi Motori Neonatali */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-accent/10 text-accent border-accent/20">
              Specializzazione TNPEE
            </Badge>
            <h2 className="text-4xl font-bold">Disturbi Motori del Neonato</h2>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Specializzazione in Terapia della Neuropsicomotricità dell'Età Evolutiva 
              per il trattamento precoce dei disturbi motori neonatali
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/plagiocefalia_trattamento_1.jpeg" 
                  alt="Trattamento Plagiocefalie"
                  className="w-full h-32 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2">
                  <Badge className="bg-blue-500/90 text-white border-white/30 text-xs">
                    PLAGIOCEFALIE
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm">Plagiocefalie</CardTitle>
                <CardDescription className="text-xs">
                  Deformità craniche posizionali e brachicefalie
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="space-y-1">
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Terapia manuale</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Posizionamento</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/terapia_neonatale_1.jpeg" 
                  alt="Torcicollo Miogeno"
                  className="w-full h-32 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2">
                  <Badge className="bg-green-500/90 text-white border-white/30 text-xs">
                    TORCICOLLO
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm">Torcicollo Miogeno</CardTitle>
                <CardDescription className="text-xs">
                  Torcicollo miogeno congenito e acquisito
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="space-y-1">
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Stretching specifico</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Mobilizzazione</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/terapia_neonatale_2.jpeg" 
                  alt="Paralisi Ostetriche"
                  className="w-full h-32 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2">
                  <Badge className="bg-red-500/90 text-white border-white/30 text-xs">
                    PARALISI
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm">Paralisi Ostetriche</CardTitle>
                <CardDescription className="text-xs">
                  Lesioni del plesso brachiale neonatale
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="space-y-1">
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Riabilitazione neurologica</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Stimolazione</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/terapia_neonatale_1.jpeg" 
                  alt="Disturbi Motori"
                  className="w-full h-32 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-2 left-2">
                  <Badge className="bg-purple-500/90 text-white border-white/30 text-xs">
                    SVILUPPO
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-2">
                <CardTitle className="text-sm">Disturbi Motori</CardTitle>
                <CardDescription className="text-xs">
                  Ritardi psicomotori e alterazioni del tono
                </CardDescription>
              </CardHeader>
              <CardContent className="pt-0">
                <div className="space-y-1">
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Valutazione precoce</span>
                  </div>
                  <div className="flex items-center space-x-1">
                    <CheckCircle className="h-3 w-3 text-accent" />
                    <span className="text-xs">Intervento mirato</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <div className="bg-gradient-to-r from-accent/5 to-primary/5 p-8 rounded-2xl max-w-5xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">Perché l'Intervento Precoce è Fondamentale?</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto">
                    <Clock className="h-6 w-6 text-accent" />
                  </div>
                  <h4 className="font-semibold">Tempestività</h4>
                  <p className="text-muted-foreground">I primi mesi sono cruciali per lo sviluppo</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                    <Target className="h-6 w-6 text-primary" />
                  </div>
                  <h4 className="font-semibold">Plasticità</h4>
                  <p className="text-muted-foreground">Il cervello neonatale ha massima adattabilità</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto">
                    <Heart className="h-6 w-6 text-secondary" />
                  </div>
                  <h4 className="font-semibold">Prevenzione</h4>
                  <p className="text-muted-foreground">Evita complicazioni future</p>
                </div>
              </div>
              <div className="mt-6">
                <Button size="lg" className="medical-gradient text-white" onClick={() => window.location.href = '/servizi'}>
                  Scopri i Trattamenti Neonatali
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Massaggi e Benessere Section */}
      <section className="section-padding bg-gradient-to-br from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-green-100 text-green-700 border-green-200 dark:bg-green-900/30 dark:text-green-300">
              Massaggi e Benessere
            </Badge>
            <h2 className="text-4xl font-bold">Tecniche di Rilassamento</h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Massaggi terapeutici specializzati per il rilassamento muscolare, la riduzione dello stress e il benessere psico-fisico completo
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="group hover:shadow-lg smooth-transition border-green-100 dark:border-green-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/massaggio_rilassante_1.jpeg" 
                    alt="Massaggi Rilassanti" 
                    className="w-full h-32 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <Flower2 className="h-4 w-4 text-green-600" />
                  </div>
                </div>
                <CardTitle className="text-sm">Massaggi Rilassanti</CardTitle>
                <p className="text-xs text-muted-foreground mt-2">Tecnica Pompage per rilassamento profondo</p>
                <div className="flex items-center gap-2 mt-3">
                  <CheckCircle className="h-3 w-3 text-green-600" />
                  <span className="text-xs">Riduzione stress</span>
                </div>
              </CardContent>
            </Card>

            <Card className="group hover:shadow-lg smooth-transition border-blue-100 dark:border-blue-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/riflessologia_plantare_1.png"
                    alt="Riflessologia Plantare" 
                    className="w-full h-32 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <Hand className="h-4 w-4 text-blue-600" />
                  </div>
                </div>
                <CardTitle className="text-sm">Riflessologia Plantare</CardTitle>
                <p className="text-xs text-muted-foreground mt-2">Pressione su punti riflessi dei piedi</p>
                <div className="flex items-center gap-2 mt-3">
                  <CheckCircle className="h-3 w-3 text-blue-600" />
                  <span className="text-xs">Riequilibrio energetico</span>
                </div>
              </CardContent>
            </Card>

            <Card className="group hover:shadow-lg smooth-transition border-purple-100 dark:border-purple-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/massaggio_rilassante_2.jpeg" 
                    alt="Massaggio Antistress" 
                    className="w-full h-32 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <Waves className="h-4 w-4 text-purple-600" />
                  </div>
                </div>
                <CardTitle className="text-sm">Massaggio Antistress</CardTitle>
                <p className="text-xs text-muted-foreground mt-2">Deflessioni e stretching mirato</p>
                <div className="flex items-center gap-2 mt-3">
                  <CheckCircle className="h-3 w-3 text-purple-600" />
                  <span className="text-xs">Rilascio tensioni</span>
                </div>
              </CardContent>
            </Card>

            <Card className="group hover:shadow-lg smooth-transition border-amber-100 dark:border-amber-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/massaggio_svedese_1.webp"
                    alt="Massaggio Svedese" 
                    className="w-full h-32 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <Sparkles className="h-4 w-4 text-amber-600" />
                  </div>
                </div>
                <CardTitle className="text-sm">Massaggio Svedese</CardTitle>
                <p className="text-xs text-muted-foreground mt-2">Tecnica classica europea completa</p>
                <div className="flex items-center gap-2 mt-3">
                  <CheckCircle className="h-3 w-3 text-amber-600" />
                  <span className="text-xs">Rilassamento generale</span>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <div className="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20 p-8 rounded-2xl max-w-5xl mx-auto border border-green-100 dark:border-green-800">
              <h3 className="text-2xl font-bold mb-4">Benefici dei Massaggi Terapeutici</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto">
                    <Heart className="h-6 w-6 text-green-600" />
                  </div>
                  <h4 className="font-semibold">Rilassamento</h4>
                  <p className="text-muted-foreground">Riduzione stress e tensioni muscolari</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center mx-auto">
                    <Activity className="h-6 w-6 text-blue-600" />
                  </div>
                  <h4 className="font-semibold">Circolazione</h4>
                  <p className="text-muted-foreground">Miglioramento del flusso sanguigno</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-purple-100 dark:bg-purple-900/30 rounded-full flex items-center justify-center mx-auto">
                    <Shield className="h-6 w-6 text-purple-600" />
                  </div>
                  <h4 className="font-semibold">Benessere</h4>
                  <p className="text-muted-foreground">Equilibrio psico-fisico generale</p>
                </div>
              </div>
              <div className="mt-6">
                <Button size="lg" className="bg-gradient-to-r from-green-600 to-blue-600 text-white hover:from-green-700 hover:to-blue-700" onClick={() => window.location.href = '/servizi'}>
                  Scopri i Massaggi
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trattamento Scoliosi Specialistico Section */}
      <section className="section-padding bg-gradient-to-br from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-red-100 text-red-700 border-red-200 dark:bg-red-900/30 dark:text-red-300">
              Specializzazione Scoliosi
            </Badge>
            <h2 className="text-4xl font-bold">Trattamento Scoliosi Avanzato</h2>
            <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
              Valutazione e trattamento mirato individuale con metodi SEAS dell'ISICO e Schroth per la correzione tridimensionale della scoliosi
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="group hover:shadow-lg smooth-transition border-red-100 dark:border-red-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/trattamento_scoliosi_1.jpeg" 
                    alt="Metodo SEAS ISICO" 
                    className="w-full h-40 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <Compass className="h-4 w-4 text-red-600" />
                  </div>
                </div>
                <CardTitle className="text-lg mb-2">Metodo SEAS</CardTitle>
                <p className="text-sm text-muted-foreground mb-4">Specific Exercises Approach to Scoliosis dell'ISICO per auto-correzione attiva</p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-red-600" />
                    <span className="text-xs">Valutazione posturale 3D</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-red-600" />
                    <span className="text-xs">Esercizi auto-correzione</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-red-600" />
                    <span className="text-xs">Controllo progressione</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="group hover:shadow-lg smooth-transition border-orange-100 dark:border-orange-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/correzione_spinale_1.jpeg" 
                    alt="Metodo Schroth" 
                    className="w-full h-40 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <RotateCcw className="h-4 w-4 text-orange-600" />
                  </div>
                </div>
                <CardTitle className="text-lg mb-2">Metodo Schroth</CardTitle>
                <p className="text-sm text-muted-foreground mb-4">Esercizi respiratori e posturali per correzione tridimensionale</p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-orange-600" />
                    <span className="text-xs">Respirazione rotatoria</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-orange-600" />
                    <span className="text-xs">Correzione 3D</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-orange-600" />
                    <span className="text-xs">Allungamento derotativo</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="group hover:shadow-lg smooth-transition border-yellow-100 dark:border-yellow-800">
              <CardContent className="p-6">
                <div className="relative mb-4">
                  <img 
                    src="/images/esercizi_posturali_1.jpeg" 
                    alt="Valutazione Specialistica" 
                    className="w-full h-40 object-cover rounded-lg"
                  />
                  <div className="absolute top-2 right-2 w-8 h-8 bg-white/90 rounded-full flex items-center justify-center">
                    <Target className="h-4 w-4 text-yellow-600" />
                  </div>
                </div>
                <CardTitle className="text-lg mb-2">Valutazione Specialistica</CardTitle>
                <p className="text-sm text-muted-foreground mb-4">Diagnosi completa e pianificazione terapeutica personalizzata</p>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-yellow-600" />
                    <span className="text-xs">Misurazione angoli Cobb</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-yellow-600" />
                    <span className="text-xs">Classificazione curva</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <CheckCircle className="h-3 w-3 text-yellow-600" />
                    <span className="text-xs">Piano personalizzato</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <div className="bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20 p-8 rounded-2xl max-w-5xl mx-auto border border-red-100 dark:border-red-800">
              <h3 className="text-2xl font-bold mb-4">Perché Scegliere il Nostro Approccio alla Scoliosi?</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto">
                    <Award className="h-6 w-6 text-red-600" />
                  </div>
                  <h4 className="font-semibold">Metodi Certificati</h4>
                  <p className="text-muted-foreground">SEAS ISICO e Schroth riconosciuti internazionalmente</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center mx-auto">
                    <Target className="h-6 w-6 text-orange-600" />
                  </div>
                  <h4 className="font-semibold">Trattamento Mirato</h4>
                  <p className="text-muted-foreground">Approccio individuale per ogni tipologia di scoliosi</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mx-auto">
                    <Clock className="h-6 w-6 text-yellow-600" />
                  </div>
                  <h4 className="font-semibold">Monitoraggio</h4>
                  <p className="text-muted-foreground">Controllo costante della progressione</p>
                </div>
              </div>
              <div className="mt-6">
                <Button size="lg" className="bg-gradient-to-r from-red-600 to-orange-600 text-white hover:from-red-700 hover:to-orange-700" onClick={() => window.location.href = '/servizi'}>
                  Scopri i Trattamenti Scoliosi
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tecnologie Avanzate Section */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-accent/10 text-accent border-accent/20">
              Tecnologie Avanzate
            </Badge>
            <h2 className="text-4xl font-bold">Innovazione al Servizio della Salute</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Utilizziamo le più moderne tecnologie per valutazioni precise 
              e programmi di riabilitazione personalizzati
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/analisi_posturale_digitale_1.webp" 
                  alt="Analisi Posturale APECS"
                  className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <Activity className="h-6 w-6 text-white" />
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-primary/90 text-white border-white/30 text-xs">
                    APECS
                  </Badge>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Analisi Posturale Digitale</CardTitle>
                <CardDescription>
                  Valutazione posturale attraverso fotogrammetria per analisi rapida e precisa del corpo
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Metodo APECS certificato</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Fotogrammetria avanzata</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Report dettagliato</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/screening_scoliosi_2.jpeg" 
                  alt="Screening ISICO"
                  className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <Target className="h-6 w-6 text-white" />
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-secondary/90 text-white border-white/30 text-xs">
                    ISICO
                  </Badge>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Screening Scoliosi</CardTitle>
                <CardDescription>
                  Valutazione specializzata per scoliosi e dorso curvo secondo protocolli ISICO
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Protocolli ISICO</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Valutazione evolutiva</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Follow-up periodico</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/software_allenamento_2.png" 
                  alt="Software Allenamento"
                  className="w-full h-48 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                    <Shield className="h-6 w-6 text-white" />
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-accent/90 text-white border-white/30 text-xs">
                    PRO
                  </Badge>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Software Personalizzati</CardTitle>
                <CardDescription>
                  Programmi di allenamento con Trainer Program 3.0 e Training Program Pro
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">App dedicate</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Monitoraggio digitale</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <CheckCircle className="h-4 w-4 text-accent" />
                    <span className="text-sm">Programmi adattivi</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <div className="bg-primary/5 p-8 rounded-2xl max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">Perché Scegliere le Nostre Tecnologie?</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                <div className="flex items-center space-x-2">
                  <CheckCircle className="h-5 w-5 text-primary" />
                  <span><strong>Precisione:</strong> Valutazioni oggettive e ripetibili</span>
                </div>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="h-5 w-5 text-primary" />
                  <span><strong>Efficienza:</strong> Risultati rapidi e dettagliati</span>
                </div>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="h-5 w-5 text-primary" />
                  <span><strong>Personalizzazione:</strong> Programmi su misura</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Terapie Strumentali Section */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-16">
            <Badge className="bg-primary/10 text-primary border-primary/20">
              Terapie Strumentali
            </Badge>
            <h2 className="text-4xl font-bold">Apparecchiature BTL Professionali</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Utilizziamo le più avanzate apparecchiature elettromedicali BTL 
              per trattamenti efficaci e sicuri
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/laser_terapia_1.jpeg" 
                  alt="Laser Terapia BTL"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <Badge className="bg-red-500/90 text-white border-white/30 text-xs">
                    LASER
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-3">
                <CardTitle className="text-base">Laser Terapia</CardTitle>
                <CardDescription className="text-sm">
                  Laser ad alta potenza per riduzione dolore e guarigione accelerata
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/tecar_terapia_1.png" 
                  alt="Tecar Terapia"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <Badge className="bg-orange-500/90 text-white border-white/30 text-xs">
                    TECAR
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-3">
                <CardTitle className="text-base">Tecar Terapia</CardTitle>
                <CardDescription className="text-sm">
                  Diatermia a radiofrequenza per rigenerazione tissutale
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/onde_urto_2.png" 
                  alt="Onde d'Urto"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <Badge className="bg-blue-500/90 text-white border-white/30 text-xs">
                    ONDE D'URTO
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-3">
                <CardTitle className="text-base">Onde d'Urto</CardTitle>
                <CardDescription className="text-sm">
                  Trattamento calcificazioni e patologie muscolo-scheletriche
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/apparecchiature_btl_1.jpeg" 
                  alt="TENS EMS"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <Badge className="bg-green-500/90 text-white border-white/30 text-xs">
                    TENS/EMS
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-3">
                <CardTitle className="text-base">TENS e EMS</CardTitle>
                <CardDescription className="text-sm">
                  Elettrostimolazione per controllo dolore e rinforzo muscolare
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/apparecchiature_btl_2.jpeg" 
                  alt="Ultrasuoni"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <Badge className="bg-purple-500/90 text-white border-white/30 text-xs">
                    ULTRASUONI
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-3">
                <CardTitle className="text-base">Ultrasuoni</CardTitle>
                <CardDescription className="text-sm">
                  Terapia tradizionale e cristalli per penetrazione profonda
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/apparecchiature_btl_2.jpeg" 
                  alt="Magnetoterapia"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <Badge className="bg-indigo-500/90 text-white border-white/30 text-xs">
                    MAGNETO
                  </Badge>
                </div>
              </div>
              <CardHeader className="pb-3">
                <CardTitle className="text-base">Magnetoterapia</CardTitle>
                <CardDescription className="text-sm">
                  Campi magnetici per rigenerazione ossea e tissutale
                </CardDescription>
              </CardHeader>
            </Card>
          </div>

          <div className="text-center mt-12">
            <div className="bg-gradient-to-r from-primary/5 to-secondary/5 p-8 rounded-2xl max-w-5xl mx-auto">
              <h3 className="text-2xl font-bold mb-6">Perché Scegliere le Apparecchiature BTL?</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                    <Award className="h-6 w-6 text-primary" />
                  </div>
                  <h4 className="font-semibold">Qualità Certificata</h4>
                  <p className="text-sm text-muted-foreground">Apparecchiature certificate CE e FDA</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center mx-auto">
                    <Target className="h-6 w-6 text-secondary" />
                  </div>
                  <h4 className="font-semibold">Precisione</h4>
                  <p className="text-sm text-muted-foreground">Trattamenti mirati e controllati</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center mx-auto">
                    <Shield className="h-6 w-6 text-accent" />
                  </div>
                  <h4 className="font-semibold">Sicurezza</h4>
                  <p className="text-sm text-muted-foreground">Protocolli sicuri e testati</p>
                </div>
                <div className="text-center space-y-2">
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
                    <Activity className="h-6 w-6 text-primary" />
                  </div>
                  <h4 className="font-semibold">Efficacia</h4>
                  <p className="text-sm text-muted-foreground">Risultati clinicamente provati</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Perché Sceglierci Section */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="space-y-4">
                <Badge className="bg-accent/10 text-accent border-accent/20">
                  Perché Sceglierci
                </Badge>
                <h2 className="text-4xl font-bold">
                  Professionalità e Competenza al Tuo Servizio
                </h2>
                <p className="text-lg text-muted-foreground">
                  Con anni di esperienza e formazione continua, garantiamo 
                  trattamenti di alta qualità per il tuo benessere.
                </p>
              </div>

              <div className="space-y-6">
                {vantaggi.map((vantaggio, index) => <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <vantaggio.icon className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-2">{vantaggio.title}</h3>
                      <p className="text-muted-foreground">{vantaggio.description}</p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <img src="/images/terapia_esercizi_2.webp" alt="Terapia fisica" className="w-full h-64 object-cover rounded-lg medical-shadow" />
                <img src="/images/ginnastica_posturale_2.jpeg" alt="Ginnastica posturale" className="w-full h-64 object-cover rounded-lg medical-shadow mt-8" />
              </div>
              
              <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-white p-6 rounded-lg medical-shadow">
                <div className="text-center">
                  <div className="text-3xl font-bold text-primary">25+</div>
                  <div className="text-sm text-muted-foreground">Anni di Esperienza</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Qualifiche Section */}
      <section className="section-padding bg-muted/30">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-12">
            <Badge className="bg-secondary/10 text-secondary border-secondary/20">
              Qualifiche Professionali
            </Badge>
            <h2 className="text-4xl font-bold">Formazione e Competenze</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {qualifiche.map((qualifica, index) => <div key={index} className="flex items-center space-x-3 medical-card p-4">
                <CheckCircle className="h-5 w-5 text-accent flex-shrink-0" />
                <span className="font-medium">{qualifica}</span>
              </div>)}
          </div>

          <div className="mt-12 text-center space-y-4">
            <div className="flex justify-center space-x-8 text-sm text-muted-foreground">
              <div>Iscr. Albo TSRM-PSTRP n. ME 67</div>
              <div>Iscr. Albo Reg. Naz. C.S.A.In</div>
            </div>
          </div>

          {/* Statistiche Formazione */}
          <div className="mt-16">
            <div className="bg-gradient-to-r from-primary/5 to-secondary/5 p-8 rounded-2xl">
              <h3 className="text-2xl font-bold text-center mb-8">Formazione Continua</h3>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-6 text-center">
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-primary">10+</div>
                  <div className="text-sm text-muted-foreground">Istituzioni di Formazione</div>
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-secondary">25+</div>
                  <div className="text-sm text-muted-foreground">Corsi Specialistici</div>
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-accent">7+</div>
                  <div className="text-sm text-muted-foreground">Diplomi e Certificazioni</div>
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-primary">20+</div>
                  <div className="text-sm text-muted-foreground">Anni di Studio</div>
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-secondary">5+</div>
                  <div className="text-sm text-muted-foreground">Collaborazioni Internazionali</div>
                </div>
              </div>
              <div className="text-center mt-6">
                <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
                  La formazione continua presso le più prestigiose istituzioni nazionali e internazionali 
                  garantisce l'applicazione delle metodologie più avanzate e aggiornate
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Articoli e Consigli Section */}
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center space-y-4 mb-12">
            <Badge className="bg-accent/10 text-accent border-accent/20">
              Articoli e Consigli
            </Badge>
            <h2 className="text-4xl font-bold">Centro Educativo</h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Scopri i nostri articoli scientifici, consigli posturali ed esercizi 
              per prenderti cura della tua salute ogni giorno.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/terapia_esercizi_4.jpeg" 
                  alt="Consigli posturali"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute top-3 left-3">
                  <Badge className="bg-green-500/90 text-white border-white/30 text-xs">
                    <Users className="h-3 w-3 mr-1" />
                    Consigli Posturali
                  </Badge>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Postura Corretta al Lavoro</CardTitle>
                <CardDescription>
                  Scopri come organizzare la tua postazione e prevenire dolori alla schiena
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
                  <span>4 min di lettura</span>
                  <span>Molto popolare</span>
                </div>
                <Link to="/articoli">
                  <Button variant="outline" className="w-full group">
                    Leggi Articolo
                    <ArrowRight className="ml-2 h-3 w-3 group-hover:translate-x-1 smooth-transition" />
                  </Button>
                </Link>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/ginnastica_posturale_1.jpeg" 
                  alt="Esercizi bambini"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute top-3 left-3">
                  <Badge className="bg-purple-500/90 text-white border-white/30 text-xs">
                    <Baby className="h-3 w-3 mr-1" />
                    Età Evolutiva
                  </Badge>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Ginnastica per Bambini</CardTitle>
                <CardDescription>
                  Attività divertenti per aiutare i più piccoli a sviluppare una postura corretta
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
                  <span>3 min di lettura</span>
                  <span>Per genitori</span>
                </div>
                <Link to="/articoli">
                  <Button variant="outline" className="w-full group">
                    Leggi Articolo
                    <ArrowRight className="ml-2 h-3 w-3 group-hover:translate-x-1 smooth-transition" />
                  </Button>
                </Link>
              </CardContent>
            </Card>

            <Card className="medical-card group hover:scale-105 smooth-transition">
              <div className="relative overflow-hidden rounded-t-xl">
                <img 
                  src="/images/fisioterapia_centro_3.jpeg" 
                  alt="Fisioterapia scientifica"
                  className="w-full h-40 object-cover group-hover:scale-110 smooth-transition"
                />
                <div className="absolute top-3 left-3">
                  <Badge className="bg-blue-500/90 text-white border-white/30 text-xs">
                    <BookOpen className="h-3 w-3 mr-1" />
                    Articoli Scientifici
                  </Badge>
                </div>
              </div>
              <CardHeader>
                <CardTitle className="text-lg">Fisioterapia Post-Chirurgica</CardTitle>
                <CardDescription>
                  Come la fisioterapia accelera il recupero dopo un intervento ortopedico
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex items-center justify-between text-sm text-muted-foreground mb-4">
                  <span>6 min di lettura</span>
                  <span>Evidenze scientifiche</span>
                </div>
                <Link to="/articoli">
                  <Button variant="outline" className="w-full group">
                    Leggi Articolo
                    <ArrowRight className="ml-2 h-3 w-3 group-hover:translate-x-1 smooth-transition" />
                  </Button>
                </Link>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <Link to="/articoli">
              <Button size="lg" className="medical-gradient text-white group">
                Vedi Tutti gli Articoli
                <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 smooth-transition" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding medical-gradient text-white">
        <div className="container-custom text-center space-y-8">
          <h2 className="text-4xl font-bold">Inizia il Tuo Percorso di Guarigione</h2>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Contattaci oggi stesso per una consulenza personalizzata e scopri 
            come possiamo aiutarti a ritrovare il benessere.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              variant="secondary" 
              className="bg-white text-primary hover:bg-white/90"
              onClick={() => window.open('https://www.sumupbookings.com/dott-papa-peppino-salvatore', '_blank')}
            >
              <Calendar className="mr-2 h-4 w-4" />
              Prenota Online
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10" asChild>
              <a href="tel:+393475391433">
                <Phone className="mr-2 h-4 w-4" />
                Chiama: +39 347 5391433
              </a>
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>;
};
export default Index;